// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"SmallMenu_menuButton__3u6BD","dots":"SmallMenu_dots__1QDLC","open":"SmallMenu_open__UxW1V","menu":"SmallMenu_menu__3bjsW"};